import { searchRequestData } from '../../Utility/apiHelper';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionType from './type';


export const requestGetAllMerchant = (queryparams) => async(dispatch) => {
    dispatch(requestShowLoader())
   try {
    dispatch({
            type: actionType?.REQUEST_GET_ALL_MERCHANTS
        })
            const vendorSearchUrl = `${process.env.REACT_APP_BASE_URL}vendors`;
            const responsedata = await searchRequestData(queryparams , vendorSearchUrl , false)
        dispatch({
            type: actionType.RECEIVED_GET_ALL_MERCHANTS,
            payload: responsedata?.data
        })
        
    } catch(error) {
    }
    dispatch(requestHideLoader())
}